class Notify {
  constructor(notify) {
    this.enabled = notify.enabled
    this.toRoom = notify.toRoom
    this.eventName = notify.eventName
  }
}

module.exports = Notify
